import { useEffect, useState } from "react";
import { api } from "@tc/ui";
let notes = null;
const listeners = new Set();
let timer = null;
let inflight = null;
export function refreshNotes() {
    if (inflight)
        return inflight;
    inflight = api("/api/notifications").then((n) => { notes = n; for (const l of listeners)
        l(n); }, () => undefined).finally(() => { inflight = null; });
    return inflight;
}
export function useNotes() {
    const [n, setN] = useState(notes);
    useEffect(() => {
        listeners.add(setN);
        setN(notes);
        if (!timer) {
            void refreshNotes();
            timer = window.setInterval(() => void refreshNotes(), 60_000);
            document.addEventListener("visibilitychange", () => { if (document.visibilityState === "visible")
                void refreshNotes(); });
        }
        return () => { listeners.delete(setN); };
    }, []);
    return n;
}
export async function markRead(ids) {
    await api("/api/notifications/read", { method: "POST", body: ids === "all" ? { all: true } : { ids } }).catch(() => undefined);
    await refreshNotes();
}
